import { useBasicSettings } from "./useBasicSettings";

export const useAdvancedOptions = () => {
  const { settings } = useBasicSettings();

  return settings?.enable_advanced_options ?? false;
};
